import styles from './index.css';

// Please replace, if IE11-support isn't required any longer.
//import {useFormContext} from 'react-hook-form';
import {useFormContext} from 'react-hook-form/dist/react-hook-form.ie11';

import * as React from 'react';
import {get} from 'lodash';
import classNames from 'classnames';

import {Option} from '../../Definitions';
import Icon from '../Icon';
import {useHandlerOnOuterClick} from '../../Utils/Hooks';

type SelectboxProps = {
	name: string;
	options: Option[];
	required?: boolean;
	hasEmptyOption?: boolean;
	displayTiny?: boolean;
	className?: string;
	onChange: (value: string|number) => void;
}
export default (props: SelectboxProps) => {
	const {onChange, name, required = false, options = [], hasEmptyOption = false, displayTiny, className} = props;

	if (!name) {
		console.warn('Missing "name" for Selectbox.');
		return null;
	}

	if (!options.length) {
		console.warn('Missing "options" for Selectbox.');
		return null;
	}

	// Toggle-state.
	const [isOpen, setIsOpen] = React.useState(false);
	const toggle = () => setIsOpen(!isOpen);
	const close = () => setIsOpen(false);
	const {node, enableHandler, disableHandler} = useHandlerOnOuterClick(close, false);

	React.useEffect(() => {
		if (isOpen) {
			enableHandler();
		} else {
			disableHandler();
		}
	}, [isOpen]);

	const {setValue, register, getValues, errors} = useFormContext();
	const isInvalid = Boolean(get(errors, name));

	const select = (value: string|number) => () => {
		setValue(name, value, true);
		if (onChange instanceof Function) {
			onChange(value);
		}

		close();
	};

	const selectedValue = get(getValues({nest: true}), name, '');
	const {label, content, value = ''} = options.find(({value}) => selectedValue === value) || {};
	const hasValue = value !== '';

	return (
		<div
			ref={node}
			className={classNames(
				styles.selectbox,
				isOpen && styles.isOpen,
				isInvalid && styles.isInvalid,
				!hasValue && required && styles.isRequired,
				displayTiny && styles.displayTiny,
				className,
			)}
		>
			<div
				onClick={toggle}
				className={styles.toggler}
			>
				<div className={styles.value}>
					{content || label || value}
				</div>
				<input type="hidden" name={name} ref={register({required})}/>
				<Icon name="chevron-down" isFlipped={isOpen} className={styles.icon}/>
			</div>
			<div className={styles.options}>
				{
					hasEmptyOption && (
						<div
							key=""
							className={styles.option}
							onClick={select('')}
						></div>
					)
				}
				{
					options.map(({value, content, label}) => (
						<div
							key={value}
							className={styles.option}
							onClick={select(value)}
						>
							{content || label || value}
						</div>
					))
				}
			</div>
		</div>
	);
}
